// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Seller plan payback popup and card. Class names are all \`sppb-\` scoped and built from divs on
 * purpose: public/css/index.css restyles bare article/aside/section under \`div.page\` at any depth.
 * Colors come from the dashboard tokens so the dark theme works; fallbacks keep it readable
 * where the tokens are absent.
 */

.sppb-overlay {
  align-items: center;
  background: rgba(10, 20, 14, 0.55);
  box-sizing: border-box;
  display: flex;
  inset: 0;
  justify-content: center;
  padding: 1rem;
  position: fixed;
  z-index: 10000;
}

.sppb-dialog {
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border-soft, #ddd);
  border-radius: 1rem;
  box-shadow: 0 1.5rem 3rem rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  color: var(--color-text, #1d2e23);
  max-height: calc(100vh - 2rem);
  max-width: 32rem;
  overflow-y: auto;
  padding: 2rem 1.75rem 1.5rem;
  position: relative;
  text-align: center;
  width: 100%;
}

.sppb-dialog:focus {
  outline: none;
}

.sppb-dialog:focus-visible {
  outline: 2px solid var(--color-accent, #316c29);
  outline-offset: 2px;
}

.sppb-close {
  background: transparent;
  border: 0;
  border-radius: 50%;
  color: inherit;
  cursor: pointer;
  font-size: 1.1rem;
  height: 2.5rem;
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  width: 2.5rem;
}

.sppb-close:hover {
  background: var(--color-hover-bg, #e9e9e9);
}

.sppb-badge {
  align-items: center;
  background: var(--color-success-bg, #d4edda);
  border-radius: 50%;
  color: var(--color-success-text, #155724);
  display: inline-flex;
  font-size: 1.75rem;
  height: 4rem;
  justify-content: center;
  margin-bottom: 0.75rem;
  width: 4rem;
}

.sppb-dialog h2,
.sppb-card h2 {
  line-height: 1.25;
  margin: 0 0 0.5rem;
}

.sppb-dialog p {
  margin: 0 0 1rem;
}

.sppb-details {
  margin: 0 0 1.25rem;
  text-align: left;
}

.sppb-details summary {
  cursor: pointer;
  font-weight: 600;
  padding: 0.35rem 0;
  text-align: center;
}

.sppb-figures {
  display: grid;
  gap: 0.6rem;
  margin: 0.75rem 0;
}

.sppb-figures > div {
  background: var(--color-surface-soft, #f4f4f4);
  border-radius: 0.5rem;
  padding: 0.6rem 0.8rem;
}

.sppb-figures dt {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.sppb-figures dd {
  font-size: 1.05rem;
  font-weight: 600;
  margin: 0.15rem 0 0;
}

.sppb-figures small {
  display: block;
  font-size: 0.8rem;
  font-weight: 400;
  margin-top: 0.15rem;
  opacity: 0.8;
}

.sppb-notes {
  font-size: 0.9rem;
  margin: 0 0 0.75rem;
  padding-left: 1.25rem;
}

.sppb-hypothetical {
  font-size: 0.85rem;
  margin: 0;
  opacity: 0.85;
}

.sppb-dialog .sppb-details .sppb-hypothetical {
  margin: 0;
}

.sppb-actions {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.25rem;
  justify-content: center;
}

.sppb-help {
  color: var(--color-link, #316c29);
}

.sppb-card {
  background: var(--color-surface, #fff);
  border: 1px solid var(--color-border-soft, #ddd);
  border-left: 4px solid var(--color-accent, #316c29);
  border-radius: 0.75rem;
  box-sizing: border-box;
  color: var(--color-text, #1d2e23);
  padding: 1.25rem;
}

.sppb-card p {
  margin: 0 0 0.75rem;
}

.sppb-eyebrow {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin: 0 0 0.35rem;
  opacity: 0.75;
  text-transform: uppercase;
}

.sppb-card .sppb-meta {
  font-size: 0.9rem;
  opacity: 0.85;
}

.sppb-card .sppb-details summary {
  text-align: left;
}

.sppb-card .sppb-details {
  margin-bottom: 0.75rem;
}

/* Motion only when the visitor has not asked for less of it. */
@media (prefers-reduced-motion: no-preference) {
  .sppb-overlay {
    animation: sppb-fade 180ms ease-out;
  }

  .sppb-dialog {
    animation: sppb-rise 240ms ease-out;
  }

  .sppb-badge {
    animation: sppb-pop 420ms cubic-bezier(0.2, 1.4, 0.4, 1) 120ms both;
  }
}

@keyframes sppb-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes sppb-rise {
  from { opacity: 0; transform: translateY(0.75rem); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes sppb-pop {
  from { transform: scale(0.6); }
  to { transform: scale(1); }
}

@media (max-width: 30rem) {
  .sppb-dialog {
    padding: 1.75rem 1.1rem 1.25rem;
  }

  .sppb-actions {
    flex-direction: column;
  }

  .sppb-actions .button {
    width: 100%;
  }
}

/* Harness only (bktestpage) */
.sppb-harness {
  display: grid;
  gap: 1rem;
}

.sppb-harness-controls {
  display: grid;
  gap: 0.75rem;
}

.sppb-harness-controls fieldset {
  border: 1px solid var(--color-border-soft, #ddd);
  border-radius: 0.5rem;
  margin: 0;
  padding: 0.5rem 0.75rem 0.75rem;
}

.sppb-harness-controls label {
  display: block;
  margin: 0.2rem 0;
}

.sppb-harness-controls small {
  display: block;
  margin-left: 1.5rem;
  opacity: 0.8;
}

.sppb-harness-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.sppb-harness-surfaces {
  display: grid;
  gap: 1rem;
}

.sppb-harness-surface {
  border: 1px dashed var(--color-border, #ccc);
  border-radius: 0.5rem;
  padding: 0.75rem;
}

.sppb-harness-surface > h3 {
  font-size: 0.9rem;
  margin: 0 0 0.5rem;
}

.sppb-harness-empty {
  font-size: 0.9rem;
  margin: 0;
  opacity: 0.75;
}

.sppb-harness-debug {
  font-size: 0.8rem;
  margin: 0;
  max-height: 22rem;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Billing/SellerPlanPayback.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;EACE,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;EACtB,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,mBAAmB;EACnB,6CAA6C;EAC7C,sBAAsB;EACtB,iCAAiC;EACjC,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,yCAAyC;EACzC,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;EAC9C,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;EAChD,mDAAmD;EACnD,sBAAsB;EACtB,sBAAsB;EACtB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mEAAmE;EACrE;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,8BAA8B,EAAE;EACnD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,qBAAqB,EAAE;EAC9B,KAAK,mBAAmB,EAAE;AAC5B;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gDAAgD;EAChD,qBAAqB;EACrB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB","sourcesContent":["/*\n * Seller plan payback popup and card. Class names are all `sppb-` scoped and built from divs on\n * purpose: public/css/index.css restyles bare article/aside/section under `div.page` at any depth.\n * Colors come from the dashboard tokens so the dark theme works; fallbacks keep it readable\n * where the tokens are absent.\n */\n\n.sppb-overlay {\n  align-items: center;\n  background: rgba(10, 20, 14, 0.55);\n  box-sizing: border-box;\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  padding: 1rem;\n  position: fixed;\n  z-index: 10000;\n}\n\n.sppb-dialog {\n  background: var(--color-surface, #fff);\n  border: 1px solid var(--color-border-soft, #ddd);\n  border-radius: 1rem;\n  box-shadow: 0 1.5rem 3rem rgba(0, 0, 0, 0.25);\n  box-sizing: border-box;\n  color: var(--color-text, #1d2e23);\n  max-height: calc(100vh - 2rem);\n  max-width: 32rem;\n  overflow-y: auto;\n  padding: 2rem 1.75rem 1.5rem;\n  position: relative;\n  text-align: center;\n  width: 100%;\n}\n\n.sppb-dialog:focus {\n  outline: none;\n}\n\n.sppb-dialog:focus-visible {\n  outline: 2px solid var(--color-accent, #316c29);\n  outline-offset: 2px;\n}\n\n.sppb-close {\n  background: transparent;\n  border: 0;\n  border-radius: 50%;\n  color: inherit;\n  cursor: pointer;\n  font-size: 1.1rem;\n  height: 2.5rem;\n  position: absolute;\n  right: 0.5rem;\n  top: 0.5rem;\n  width: 2.5rem;\n}\n\n.sppb-close:hover {\n  background: var(--color-hover-bg, #e9e9e9);\n}\n\n.sppb-badge {\n  align-items: center;\n  background: var(--color-success-bg, #d4edda);\n  border-radius: 50%;\n  color: var(--color-success-text, #155724);\n  display: inline-flex;\n  font-size: 1.75rem;\n  height: 4rem;\n  justify-content: center;\n  margin-bottom: 0.75rem;\n  width: 4rem;\n}\n\n.sppb-dialog h2,\n.sppb-card h2 {\n  line-height: 1.25;\n  margin: 0 0 0.5rem;\n}\n\n.sppb-dialog p {\n  margin: 0 0 1rem;\n}\n\n.sppb-details {\n  margin: 0 0 1.25rem;\n  text-align: left;\n}\n\n.sppb-details summary {\n  cursor: pointer;\n  font-weight: 600;\n  padding: 0.35rem 0;\n  text-align: center;\n}\n\n.sppb-figures {\n  display: grid;\n  gap: 0.6rem;\n  margin: 0.75rem 0;\n}\n\n.sppb-figures > div {\n  background: var(--color-surface-soft, #f4f4f4);\n  border-radius: 0.5rem;\n  padding: 0.6rem 0.8rem;\n}\n\n.sppb-figures dt {\n  font-size: 0.8rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.sppb-figures dd {\n  font-size: 1.05rem;\n  font-weight: 600;\n  margin: 0.15rem 0 0;\n}\n\n.sppb-figures small {\n  display: block;\n  font-size: 0.8rem;\n  font-weight: 400;\n  margin-top: 0.15rem;\n  opacity: 0.8;\n}\n\n.sppb-notes {\n  font-size: 0.9rem;\n  margin: 0 0 0.75rem;\n  padding-left: 1.25rem;\n}\n\n.sppb-hypothetical {\n  font-size: 0.85rem;\n  margin: 0;\n  opacity: 0.85;\n}\n\n.sppb-dialog .sppb-details .sppb-hypothetical {\n  margin: 0;\n}\n\n.sppb-actions {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem 1.25rem;\n  justify-content: center;\n}\n\n.sppb-help {\n  color: var(--color-link, #316c29);\n}\n\n.sppb-card {\n  background: var(--color-surface, #fff);\n  border: 1px solid var(--color-border-soft, #ddd);\n  border-left: 4px solid var(--color-accent, #316c29);\n  border-radius: 0.75rem;\n  box-sizing: border-box;\n  color: var(--color-text, #1d2e23);\n  padding: 1.25rem;\n}\n\n.sppb-card p {\n  margin: 0 0 0.75rem;\n}\n\n.sppb-eyebrow {\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  margin: 0 0 0.35rem;\n  opacity: 0.75;\n  text-transform: uppercase;\n}\n\n.sppb-card .sppb-meta {\n  font-size: 0.9rem;\n  opacity: 0.85;\n}\n\n.sppb-card .sppb-details summary {\n  text-align: left;\n}\n\n.sppb-card .sppb-details {\n  margin-bottom: 0.75rem;\n}\n\n/* Motion only when the visitor has not asked for less of it. */\n@media (prefers-reduced-motion: no-preference) {\n  .sppb-overlay {\n    animation: sppb-fade 180ms ease-out;\n  }\n\n  .sppb-dialog {\n    animation: sppb-rise 240ms ease-out;\n  }\n\n  .sppb-badge {\n    animation: sppb-pop 420ms cubic-bezier(0.2, 1.4, 0.4, 1) 120ms both;\n  }\n}\n\n@keyframes sppb-fade {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes sppb-rise {\n  from { opacity: 0; transform: translateY(0.75rem); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes sppb-pop {\n  from { transform: scale(0.6); }\n  to { transform: scale(1); }\n}\n\n@media (max-width: 30rem) {\n  .sppb-dialog {\n    padding: 1.75rem 1.1rem 1.25rem;\n  }\n\n  .sppb-actions {\n    flex-direction: column;\n  }\n\n  .sppb-actions .button {\n    width: 100%;\n  }\n}\n\n/* Harness only (bktestpage) */\n.sppb-harness {\n  display: grid;\n  gap: 1rem;\n}\n\n.sppb-harness-controls {\n  display: grid;\n  gap: 0.75rem;\n}\n\n.sppb-harness-controls fieldset {\n  border: 1px solid var(--color-border-soft, #ddd);\n  border-radius: 0.5rem;\n  margin: 0;\n  padding: 0.5rem 0.75rem 0.75rem;\n}\n\n.sppb-harness-controls label {\n  display: block;\n  margin: 0.2rem 0;\n}\n\n.sppb-harness-controls small {\n  display: block;\n  margin-left: 1.5rem;\n  opacity: 0.8;\n}\n\n.sppb-harness-buttons {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.sppb-harness-surfaces {\n  display: grid;\n  gap: 1rem;\n}\n\n.sppb-harness-surface {\n  border: 1px dashed var(--color-border, #ccc);\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n}\n\n.sppb-harness-surface > h3 {\n  font-size: 0.9rem;\n  margin: 0 0 0.5rem;\n}\n\n.sppb-harness-empty {\n  font-size: 0.9rem;\n  margin: 0;\n  opacity: 0.75;\n}\n\n.sppb-harness-debug {\n  font-size: 0.8rem;\n  margin: 0;\n  max-height: 22rem;\n  overflow: auto;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
